import type { ModuleDefinition, ModuleField, ProjectSectionBinding } from '@/types/domain';

export const modules: ModuleDefinition[] = [
  {
    key: 'projects',
    code: 'PM',
    name: '项目管理',
    caption: 'APQP 项目、计划、Gate 与交付闭环',
    route: '/modules/projects',
    entityName: '项目',
    module: 'project-management',
    resource: 'projects',
    mode: 'projects',
    columns: [
      { key: 'projectNo', label: '项目编号' },
      { key: 'projectName', label: '项目名称' },
      { key: 'customer', label: '客户' },
      { key: 'projectManager', label: '项目经理' },
    ],
    fields: [
      { key: 'projectNo', label: '项目编号', required: true },
      { key: 'projectName', label: '项目名称', required: true },
      { key: 'customer', label: '客户' },
      { key: 'projectType', label: '项目类型' },
      { key: 'priority', label: '优先级', type: 'select', options: ['critical', 'high', 'normal', 'low'] },
      { key: 'startDate', label: '开始日期', type: 'date' },
      { key: 'endDate', label: '结束日期', type: 'date' },
      { key: 'description', label: '项目说明', type: 'textarea' },
    ],
    statusActions: [
      /*
        0916：「启动项目」直接写 in_progress。原来它写 active、另有一个「进入执行」
        写 in_progress，可两个值全系统没有一处区分对待，界面上也都翻成「进行中」——
        结果就是同一个"在跑"有两种写法（Tony:「统一成一种」）。
      */
      { value: 'in_progress', label: '启动项目' },
      { value: 'quotation', label: '转报价项目' },
      { value: 'paused', label: '暂停', danger: true },
      { value: 'closed', label: '关闭', danger: true },
      { value: 'cancelled', label: '取消', danger: true },
      { value: 'archived', label: '归档', danger: true },
      { value: 'deleted', label: '删除', danger: true },
      { value: 'draft', label: '恢复草稿' },
    ],
  },
  {
    key: 'dfmea',
    code: 'DF',
    name: 'DFMEA',
    caption: '结构、功能、失效、措施与再评价',
    route: '/modules/dfmea',
    entityName: 'DFMEA 项目',
    module: 'dfmea',
    resource: 'documents',
    columns: [
      { key: 'code', label: '分析编号' },
      { key: 'title', label: '分析对象' },
      { key: 'project_id', label: '关联项目' },
      { key: 'revision', label: '修订版' },
    ],
    fields: [
      { key: 'code', label: 'DFMEA 编号', required: true, group: '基本信息' },
      { key: 'title', label: '分析项目名称', required: true, group: '基本信息' },
      { key: 'projectId', label: '关联项目内部 ID', required: true, group: '基本信息' },
      { key: 'revision', label: '修订版', group: '基本信息' },
      { key: 'company', label: '公司名称', group: '分析表头' },
      { key: 'customer', label: '顾客名称', group: '分析表头' },
      { key: 'subject', label: '产品名称 / 分析对象', group: '分析表头' },
      { key: 'modelYear', label: '车型 / 年款', group: '分析表头' },
      { key: 'team', label: '核心团队', type: 'textarea', group: '组织与日期', help: '填写成员姓名，多个成员可用顿号分隔。' },
      { key: 'startDate', label: '开始日期', type: 'date', group: '组织与日期' },
      { key: 'revisionDate', label: '修订日期', type: 'date', group: '组织与日期' },
    ],
    statusActions: [
      { value: 'submitted', label: '提交评审' },
      { value: 'approved', label: '批准' },
      { value: 'active', label: '生效' },
    ],
  },
  {
    key: 'pfmea-cp',
    code: 'PF',
    name: 'PFMEA & CP',
    caption: '过程失效分析、特殊特性与控制计划联动',
    route: '/modules/pfmea-cp',
    entityName: 'PFMEA',
    module: 'pfmea-cp',
    resource: 'documents',
    columns: [
      { key: 'code', label: 'PFMEA 编号' },
      { key: 'title', label: '过程名称' },
      { key: 'project_id', label: '关联项目' },
      { key: 'revision', label: '修订版' },
    ],
    fields: [
      { key: 'code', label: 'PFMEA 编号', required: true, group: '基本信息' },
      { key: 'title', label: 'PFMEA 项目名称', required: true, group: '基本信息' },
      { key: 'projectId', label: '关联项目内部 ID', required: true, group: '基本信息' },
      { key: 'revision', label: '修订版', group: '基本信息' },
      { key: 'company', label: '公司名称', group: '分析表头' },
      { key: 'customer', label: '顾客名称', group: '分析表头' },
      { key: 'subject', label: '产品 / 过程名称', group: '分析表头' },
      { key: 'modelYear', label: '车型 / 年款', group: '分析表头' },
      { key: 'platform', label: '平台', group: '分析表头' },
      { key: 'team', label: '核心团队', type: 'textarea', group: '关联与范围' },
      { key: 'linkedDfmeaId', label: '关联 DFMEA 内部 ID', type: 'number', group: '关联与范围', help: '仅填写 DFMEA 记录的内部 ID，不使用名称推断。' },
      { key: 'itemFunction', label: '过程项功能描述', type: 'textarea', group: '关联与范围' },
      { key: 'itemFailure', label: '过程项失效描述', type: 'textarea', group: '关联与范围' },
    ],
    statusActions: [
      { value: 'submitted', label: '提交评审' },
      { value: 'approved', label: '批准' },
      { value: 'active', label: '生效' },
    ],
  },
  {
    key: 'files',
    code: 'DMS',
    name: '文件管理',
    caption: '分类、版本、审批、发布与受控归档',
    route: '/modules/files',
    entityName: '文件',
    module: 'documents',
    resource: 'documents',
    columns: [
      { key: 'code', label: '文件编号' },
      { key: 'title', label: '文件名称' },
      { key: 'revision', label: '版本' },
      { key: 'project_id', label: '关联项目' },
    ],
    fields: [
      { key: 'code', label: '文件编号', required: true, group: '文件标识' },
      { key: 'title', label: '文件 / 文件夹名称', required: true, group: '文件标识' },
      { key: 'projectId', label: '关联项目内部 ID', group: '文件标识' },
      { key: 'revision', label: '版本号', group: '文件标识' },
      { key: 'documentType', label: '记录类型', type: 'select', options: ['file', 'folder'], group: '分类与责任' },
      { key: 'category', label: '文件分类', group: '分类与责任' },
      { key: 'responsibleDepartment', label: '负责部门', group: '分类与责任' },
      { key: 'responsiblePosition', label: '负责岗位', group: '分类与责任' },
      { key: 'ownerName', label: '负责人', group: '分类与责任' },
      { key: 'fileSource', label: '文件来源', group: '受控属性' },
      { key: 'retentionYears', label: '保存期限（年）', type: 'number', group: '受控属性' },
      { key: 'approvalRequired', label: '需要审批', type: 'select', options: ['是', '否'], group: '受控属性' },
      { key: 'nextReviewDate', label: '下次审查日期', type: 'date', group: '受控属性' },
      { key: 'validityDays', label: '有效期（天）', type: 'number', group: '受控属性' },
      { key: 'changeLog', label: '版本更新说明', type: 'textarea', group: '受控属性' },
    ],
    statusActions: [
      { value: 'submitted', label: '提交审批' },
      { value: 'approved', label: '批准' },
      { value: 'active', label: '发布' },
      { value: 'obsolete', label: '作废', danger: true },
    ],
  },
  {
    key: 'issues',
    code: '8D',
    name: '问题管理',
    caption: '问题登记、D0—D8、验证与经验复用',
    route: '/modules/issues',
    // 这个模块本质是**问题清单**；8D 只是其中少数问题要走的一套方法。
    // 叫「8D 问题」会让「＋ 新建」按钮变成「新建8D 问题」，
    // 而绝大多数问题根本不需要 8D（97 条里只有 7 条有）——2026-08-18 Tony 指出。
    entityName: '问题',
    module: 'issues',
    resource: 'issues',
    columns: [
      { key: 'code', label: '问题编号' },
      { key: 'title', label: '问题描述' },
      { key: 'project_id', label: '关联项目' },
      // 和新建表单同一套口径：类型/等级/负责人/计划日期，列表上不用点进去才知道
      { key: 'category', label: '问题类型' },
      { key: 'severityGrade', label: '等级' },
      { key: 'owner_name', label: '负责人' },
      { key: 'currentPlanDate', label: '当前计划' },
    ],
    fields: [
      { key: 'code', label: '问题编号', group: '基本信息',
        help: '留空自动生成（ISS-2026-001 顺号）' },
      { key: 'title', label: '问题标题', required: true, group: '基本信息',
        help: '一句话说清现象；带上项目代号会自动挂到项目' },
      { key: 'projectId', label: '关联项目', group: '基本信息',
        help: '留空时按标题里的项目代号自动挂' },
      // 只留「问题等级」一个入口：核心列 priority 由后端按等级算，
      // 两个都给人填必然走岔（列表显示 A-严重、编辑页显示普通）
      // 0911 起必填：等级决定这条问题起步在谁手上（A 级起步项目经理层），项目灯也读它
      { key: 'severityGrade', label: '问题等级', type: 'select', options: ['A-严重', 'B-重要', 'C-一般', 'D-轻微'], required: true, group: '基本信息',
        help: 'A 级问题自动起步在项目经理层' },
      // 客户投诉直接决定项目灯：客户升级投诉 = 红，口头 / 书面 = 黄
      { key: 'customerComplaint', label: '客户投诉', type: 'select', options: ['无', '口头投诉', '书面投诉', '客户升级投诉'], group: '基本信息',
        help: '客户升级投诉 = 客户正式投诉：问题直接列入管理层、项目亮红灯；口头 / 书面投诉项目亮黄灯' },
      { key: 'description', label: '问题描述', type: 'textarea', required: true, group: '基本信息' },
      { key: 'occurrenceStage', label: '发生阶段', group: '更多（按需填）' },
      { key: 'category', label: '问题类型', group: '基本信息' },
      { key: 'foundAt', label: '问题发现时间', type: 'date', required: true, group: '基本信息' },
      // 0928 Tony：「提出人不需要选择，问题谁填写谁就是提出人」——提出人能关问题，所以由系统记、不给改
      { key: 'foundBy', label: '问题提出者', group: '基本信息', readonly: true,
        help: '自动记为填这条问题的人，不用选' },
      { key: 'location', label: '发生地点 / 工位', group: '更多（按需填）' },
      { key: 'productCategory', label: '产品类别', group: '更多（按需填）' },
      { key: 'customerName', label: '客户名称', group: '更多（按需填）' },
      { key: 'partNumber', label: '零件号', group: '基本信息',
        help: '客户零件号，与 BOM 里的「客户零件号」保持一致' },
      { key: 'partName', label: '零件名称', group: '基本信息' },
      { key: 'quantity', label: '数量', type: 'number', group: '更多（按需填）',
        help: '这次发现的不良件数量（只填数字）' },
      { key: 'traceability', label: '追溯信息', group: '更多（按需填）',
        help: '批次号 / 生产日期 / 模穴号等能倒查到货的信息，缺了就锁不定范围' },
      { key: 'requirement', label: '客户 / 内部要求', type: 'textarea', group: '更多（按需填）' },
      { key: 'mileage', label: '公里数', group: '更多（按需填）' },
      { key: 'dealerName', label: '4S 店名称', group: '更多（按需填）' },
      { key: 'claimDate', label: '索赔日期', type: 'date', group: '更多（按需填）' },
      { key: 'useMonths', label: '使用月份', type: 'number', group: '更多（按需填）' },
      { key: 'ownerUserId', label: '负责人', type: 'number', group: '基本信息',
        help: '从本项目团队或通讯录选账号；选中后双写姓名。无系统账号才用手填姓名。' },
      { key: 'ownerName', label: '负责人姓名（无系统账号）', group: '基本信息',
        help: '选人后自动带出。仅当责任人「无系统账号」时手填；手填时请清空上方账号选择。' },
      { key: 'dueAt', label: '要求完成日期', type: 'date', group: '更多（按需填）' },
      { key: 'currentPlanDate', label: '当前计划日期', type: 'date', group: '分析与措施' },
      { key: 'completedAt', label: '完成日期', type: 'date', group: '分析与措施' },
      // 「是否需要升级」已下线（0911）：升级是清单上的动作（四级 + 履历），不是一个是/否字段
      // 8D 的正文：原因和措施。之前后端存得下、界面上却没有输入框，
      // 等于这两列只能靠批量导入维护（试用反馈 8/12）
      /*
       * 5Why 链：每一层回答「上一层为什么会发生」，逐层从现象走到体系。
       * 只给五个空框没人知道怎么填（试用反馈 8/13），所以每层都写清楚要答什么、
       * 并给一个贯穿的例子：外观件表面划伤。
       */
      { key: 'why1', label: '为什么①：为什么会出现这个现象？', group: '更多（按需填）',
        help: '答直接现象。例：喷漆件表面有划伤。' },
      { key: 'why2', label: '为什么②：上一条为什么会发生？', group: '更多（按需填）',
        help: '答直接原因，通常是人/机/料/法/环里的一个。例：转运周转箱内衬破损，零件互相磕碰。' },
      { key: 'why3', label: '为什么③：再往下一层', group: '更多（按需填）',
        help: '答为什么会出现上面那个条件。例：周转箱已使用两年，未纳入点检清单。' },
      { key: 'why4', label: '为什么④：管理层面的原因', group: '更多（按需填）',
        help: '开始触及流程与标准。例：工装点检标准只覆盖模具，不含周转器具。' },
      { key: 'why5', label: '为什么⑤（根因层）', group: '更多（按需填）',
        help: '答到「改了它就不会再犯」为止，一般落在制度/标准/培训。例：器具类工装没有定义责任部门与点检周期。' },
      { key: 'rootCause', label: '问题原因分析（根因结论）', type: 'textarea', group: '分析与措施' },
      { key: 'countermeasure', label: '问题解决措施', type: 'textarea', group: '分析与措施' },
      { key: 'progressLog', label: '最新进展', type: 'textarea', group: '分析与措施' },
    ],
    statusActions: [
      { value: 'in_progress', label: '进入处置' },
      { value: 'closed', label: '关闭' },
      { value: 'cancelled', label: '取消', danger: true },
    ],
  },
  {
    key: 'changes',
    code: 'ECM',
    name: '变更管理',
    caption: '影响分析、评审、实施、断点与关闭',
    route: '/modules/changes',
    entityName: '工程变更',
    module: 'changes',
    resource: 'changes',
    columns: [
      { key: 'code', label: '变更编号' },
      { key: 'title', label: '变更主题' },
      { key: 'changeLevel', label: '等级' },
      { key: 'project_id', label: '关联项目' },
      { key: 'priority', label: '优先级' },
    ],
    fields: [
      { key: 'code', label: '变更编号', group: '变更标识',
        help: '只有一种规则（0826）：ECN-项目号-001，同项目内依次递增。挂了项目建单即编；'
          + '没挂项目先空着，第 1 步提交（或补挂项目后再提交）时补编。老数据的长串数字编号是迁移痕迹' },
      { key: 'title', label: '变更标题', required: true, group: '变更标识',
        help: '带上项目代号（如 X04-C…），系统会按代号自动挂到项目' },
      { key: 'projectId', label: '关联项目', group: '变更标识',
        help: '留空时按标题里的项目代号自动挂；对不上会保持待归属，之后可补' },
      { key: 'priority', label: '优先级', type: 'select', options: ['normal', 'high', 'critical'], group: '变更标识' },
      // 这三个是必填，但一直没有选项也没有说明，人只能凭印象填（全局审核 8/14）。
      // 类型/来源/阶段的选项在 ModuleWorkbenchView 里接了后端字典，这里只补口径。
      /*
        变更等级 A/B/C 是《工程变更控制程序》的分级管控核心（2026-08-19 按程序文件搭建）：
        A 必须取得客户**书面批准**才能实施；B 实施前告知客户留记录；C 内部备案。
        等级门禁在后端 assertChangeGate——前端只负责让人看懂怎么选。
      */
      /*
        等级这一格**在建单时就必填、不能等第 2 步**：
        后端 assertChangeClientAuthorization 是「没填等级就放行」的——
        空等级不是"还没评审"，是把 A 级的客户书面批准门禁整个关掉了。
        所以建单先按判断填一个，第 2 步《变更影响评审》评完再以那一步为准（会覆盖这里）。
      */
      { key: 'changeLevel', label: '变更等级（A/B/C）', required: true, type: 'select',
        options: ['A', 'B', 'C'], group: '来源与关联',
        help: 'A 重大：核心性能/关键尺寸/材料替换/模具重开/工艺重大调整，须客户书面批准；B 一般：过程/工装/包装/物流调整，实施前告知客户；C 轻微：内部优化/参数微调/文件纠错，内部备案即可。'
          + '第 2 步《变更影响评审》评完会以那一步填的为准；这里不许留空——没等级的单子会绕过 A 级的客户批准门禁' },
      { key: 'riskLevel', label: '风险等级', type: 'select', options: ['高', '中', '低'], group: '来源与关联',
        // 0827：审批链以第 3 步的四条路由为准，这里不再另写一套角色（写两套就会对不上）
        help: '按《产品变更风险评估表》评估后填。风险等级和变更等级决定第 3 步走哪条审批链。'
          + '正式的评定在五步的第 2 步表单里做，这里填的会被那一步覆盖' },
      { key: 'changeType', label: '变更类型', required: true, group: '来源与关联',
        help: '第 1 步的表单给「产品变更 / 过程变更」两个大类（0826 Tony 定义：产品=固有特性'
          + '（尺寸/结构/材料/性能/外观），过程=影响产品特性的因素（工艺/模具/工装/设备/工序/供应商等））；'
          + '存的仍是这个字段，老单子的旧口径照旧显示' },
      /*
        变更类型的**下级细分**（0823 Tony 手绘稿）。

        为什么另开一个字段而不是把细分塞进 changeType：
        changeType 存的是 cfg_dictionaries 的 source_pk（一串时间戳 ID），
        界面靠字典把 ID 翻成中文；写一个字典里没有的值进去，那一格就显示成空。
        细分项 Tony 还没给全，所以这里**不写死 options**——第 1 步的表单是
        「可填可选」：候选来自库里已经用过的写法，用出来的口径比猜的准。
      */
      { key: 'changeSubType', label: '变更类型（下级细分）', group: '来源与关联',
        allowFreeText: true,
        help: '大类底下具体是哪一类，如 图纸尺寸 / 模具型腔。没有现成写法就直接填，填过的会进候选' },
      { key: 'changeSource', label: '变更来源', required: true, group: '来源与关联',
        help: '这次变更是谁提出来的：客户 / 内部 / 供方' },
      // 客户发起的变更要留原文（程序 7.1「写明客户要求与完成时限」）：转述会走样，
      // 而 A 级变更最后要拿它跟客户的书面批准对账。选「客户」时第 1 步的表单会要求填
      { key: 'customerRequirement', label: '客户的变更要求（原文）', type: 'textarea',
        group: '来源与关联',
        help: '客户邮件正文 / EWO 内容原样贴进来，不要转述；来源选「客户」时必填' },
      { key: 'partNumber', label: '产品 / 零件编号', group: '来源与关联',
        help: '填客户零件号（与 BOM 里的「客户零件号」一致）；内部件号填在下面的产品版本里' },
      { key: 'productName', label: '变更产品名称', group: '来源与关联',
        help: '零件号对应的产品名，如「出风口总成」；和零件号一起看才知道改的是什么' },
      // 下拉选项接的是后端 issueProduct（和问题清单同一份产品类别库）；
      // 接口取不到时会退回成文本框，所以说明写在这里，不写在下拉里
      { key: 'productCategory', label: '产品分类', group: '来源与关联',
        help: '按工艺大类选，如 喷漆件 / 电镀件 / 注塑件；用于按产线统计变更' },
      { key: 'productVersion', label: '关联产品版本', group: '来源与关联',
        help: '内部件号 + 版本，如 A2-03；不确定就留空，不要凭印象填' },
      // 两档（0823 Tony）：量产前用 APQP 阶段码 P03–P06，量产后只有「量产后」一个取值。
      // 下拉接的是后端 issueStage（P01–P06），比这两档宽——老单子填的 P01/T0 照旧显示，不强改
      { key: 'occurrenceStage', label: '发生阶段', group: '来源与关联',
        help: '变更是在哪个阶段发生的：量产前填 P03–P06，量产后填「量产后」' },
      { key: 'relatedIssue', label: '关联问题单', group: '来源与关联',
        help: '因某个问题单引起的变更，填那张单的编号（如 ISS-2026-0007）' },
      { key: 'reason', label: '变更理由', type: 'textarea', required: true, group: '变更内容',
        help: '为什么必须改：客户要求 / 质量问题 / 降本 / 工艺不可行，写清触发点' },
      { key: 'containmentAction', label: '现有状态产品的遏制措施', type: 'textarea', group: '变更内容',
        help: '可行性评审会议决定的遏制措施：在库/在途/客户端的现状态产品怎么控住（程序 10.2.1.1）' },
      { key: 'clientAuthorization', label: '客户批准 / 告知记录', type: 'textarea', group: '变更内容',
        // 0905：只对内部 / 供方发起的变更是门禁；客户发起的以第 1 步的客户要求原文为授权
        help: '内部 / 供方发起的变更——A 级：客户书面批准的出处（邮件主题+日期、EWO 号、截图存档位置），进入实施前必填，否则流程退回；B 级：告知客户的记录；C 级可留空。'
          + '客户发起的变更不强制：授权以第 1 步的「客户的变更要求（原文）」为准' },
      { key: 'impactScopes', label: '影响范围（勾了什么，执行清单就裁成什么）', type: 'multi',
        options: ['产品尺寸/结构', '材料', '外观/颜色', '功能/性能', '安全或法规特性', '工艺/工序', '模具/工装/检具', '包装/物流'],
        group: '变更内容',
        /*
          这一格**不**跟着别的评审字段摘进第 2 步（契约 1.4 特意把它排除在外）：
          它是执行清单裁剪的输入，而第 2 步的六大类勾选只「加」不「减」——
          摘掉就没法修正老数据里手填错的粗粒度范围。所以它留在通用表单里，
          只把这层关系在 help 里说清楚。
        */
        // 0825 模板换代：37+4 退役，换成《ex执行和落地》的 44 条按阶段×角色
        help: '不勾 = 未做影响分析，清单按最全 44 条铺（按阶段×角色，大部分动作每单都铺）；'
          + '勾「安全或法规特性」或客户来源，PPAP 一条标【必须】。'
          + '第 2 步评审勾选会往里加，不会减；这里可以改' },
      /*
        第 2 步《变更影响评审》的六大类勾选结果（0823 Tony 整理稿）。

        **为什么另开一个字段，而不是把 impactScopes 换成这 30 个细子项**：
        impactScopes 是执行清单裁剪（后端 tailorChecklist）的输入，37+4 条动作
        靠上面那 8 个粗粒度值精确匹配。换掉选项 = 存量一条都对不上，
        清单要么全铺要么全不铺，而且老单子勾过的「材料」「包装/物流」会变成空白。
        所以两个字段各司其职：impactScopes 管**清单裁剪**，
        impactItems 管**评审记录**（这一步到底逐项看过什么）。
        两者不各说各话：提交第 2 步时按后端 IMPACT_ITEM_TO_SCOPE 把细子项并进
        impactScopes，**只加不减**——老数据因此不会变空。

        这里刻意不写 options：30 个子项的清单在后端（change-steps.ts），
        抄一份到前端迟早对不上。要勾就去五步里的第 2 步表单，那里的选项是后端给的。
      */
      { key: 'impactItems', label: '影响评审勾选项（第 2 步表单填）', type: 'textarea',
        group: '变更内容',
        help: '六大类下面逐项勾的结果，用「、」连接，如「技术·图纸、生产·模具」。'
          + '在五步框架的第 2 步表单里勾，这里只是让它在台账和导出里看得见。'
          + '在这里手打的写法勾选框画不出来，第 2 步会照实单独列出来，也不会被覆盖掉' },
      { key: 'beforeDescription', label: '变更前描述', type: 'textarea', group: '变更内容',
        help: '改之前是什么样：尺寸、材料、工序、外观要求，能对比才说得清影响' },
      { key: 'afterDescription', label: '变更后描述', type: 'textarea', group: '变更内容',
        help: '改之后是什么样，和上一栏一一对应' },
      /*
        台账列（C_030_4_04 变更台账模版）。放折叠组：不是每条变更都有费用，
        但要导出台账对账时这些列必须在。数字字段存文本不做算术——
        金额口径（含税/币种）系统不知道，不装作能算。
      */
      { key: 'customerChangeNo', label: '客户更改号', group: '台账与费用（按需填）',
        help: '客户侧的 CR/ECN 号；客户没有编号就留空' },
      { key: 'initiatedDept', label: '发起部门', group: '台账与费用（按需填）' },
      { key: 'changeExpense', label: '变更费用', group: '台账与费用（按需填）',
        help: '试制/模具/检具/工装/运输/报废等一次性费用合计' },
      { key: 'clientPayback', label: '客户支付', group: '台账与费用（按需填）',
        help: '客户同意承担的金额（含治具费）' },
      { key: 'costImpact', label: '变更成本', group: '台账与费用（按需填）',
        help: '产品单件成本的变化（涨写正、降写负）' },
      { key: 'priceImpact', label: '变更报价', group: '台账与费用（按需填）',
        help: '产品单价的变化（客户同意增加的价格）' },
      // 零件标识 P01→P02、总成 A01→A02（程序 10.5.1）；客户有特殊要求按客户的
      { key: 'partMarkBefore', label: '零件变更前标识', group: '实施与责任',
        help: '单件 P01/P02…，总成 A01/A02…；客户有标识要求按客户执行' },
      { key: 'partMarkAfter', label: '零件变更后标识', group: '实施与责任',
        help: '变更后的新标识，需在作业指导书/检验指导书中注明' },
      // 断点三件套要一起填才有意义：类型决定「断点值」怎么写
      { key: 'plannedBreakpoint', label: '希望断点', group: '实施与责任',
        help: '希望从哪一批开始用新状态，先写文字说明，再用下面两栏写死' },
      { key: 'breakpointType', label: '断点类型', type: 'select', options: ['date', 'batch', 'sn'], group: '实施与责任',
        help: '按日期切换 / 按生产批次 / 按产品序列号——决定「断点值」填什么' },
      { key: 'breakpointValue', label: '断点值', group: '实施与责任',
        help: '按上面选的类型填：日期填 2026-09-01，批次填批次号，序列号填起始 SN' },
      { key: 'actualBreakpoint', label: '实际断点', group: '实施与责任',
        help: '真正切换的那一批/那一天/起始SN，断点做完回来填死——审计追溯就查这一格' },
      { key: 'oldStockDisposition', label: '旧件处置', type: 'select',
        options: ['用完为止', '返工使用', '报废', '退供应商'], group: '实施与责任',
        help: '旧状态的库存和在途怎么办；客户处已发批次要不要追回，写进变更措施里' },
      { key: 'ownerName', label: '变更牵头人', group: '实施与责任' },
      { key: 'dueAt', label: '要求完成日期', type: 'date', group: '实施与责任' },
    ],
    /*
      0824：推进类的四个按钮（提交评审 / 批准 / 进入实施 / 验证闭环，关闭）撤了。
      推进现在只有一个入口——五步的「推进到第 N 步」，它同时改 current_step 和 status
      （后端 STEP_ADVANCE_STATUS）。两套入口并存的下场是库里出现
      「已关闭却停在第 1 步」：状态点了、步没推，或者反过来。

      留下的两条是五步表达不了的，必须留着，否则一条填错的变更单就退不回也作废不掉：
      - 退回修改：评审没过，打回去重填（五步只前进，不倒退）；
      - 取消：这条单子根本不该存在，作废掉（质量记录不给删，只给作废）。
    */
    statusActions: [
      { value: 'rejected', label: '退回修改' },
      { value: 'cancelled', label: '取消', danger: true },
    ],
  },
  /*
    0916 Tony 盘点：「人力资源、大屏数据、系统设置这三个模块没有任何作用，
    而且很多内容都是重复的」。查完确实如此，三张卡片撤掉——

    · **人力资源**：和「用户管理」读同一张 iam_users，而且是弱的那个。
      操作留痕 人员 5 条（全在 2026-08-02、还都是脚本动作）vs 用户管理 112 条（含今天）；
      用户管理另有整理名单、角色、直属主管、钉钉岗位同步，功能是真包含关系。
      **模块键 `hr` 留着**：它下面的 `project-members` 是团队页在用的
      （0916 当天还有 230 次增删），撤的是菜单入口，不是这个模块。
    · **大屏数据**：和顶栏那个投屏「大屏」同名不同物，这正是「不知道用来干嘛」的来源。
      里面只有一张和指挥台同源的异常清单 + 一个「重算业务指标」；
      而 dashboard-refresh 每 30 分钟已自动重算。全库 1 条留痕，最近 2026-08-05。
      那个按钮挪到用户管理页的运维区。
    · **系统设置**：页面自己就写着「审批流现在有独立模块了，去审批流模块 →」。
      它列的 25 条是 2026-07 迁来的 legacy 表单/流程清单，零编辑；
      真正有用的两块（邮件入库试点、字典只读查看）并进审批流模块。

    三个模块的**后端资源都还在**（modules.service 的 RESOURCES 没动），
    接口照旧能调；这里只是不再给它们发模块中心的入口。
  */
];

export const projectSectionBindings: ProjectSectionBinding[] = [
  {
    section: 'deliverables',
    sources: [],
  },
  { section: 'dfmea', sources: [{ module: 'dfmea', resource: 'documents', label: 'DFMEA' }] },
  { section: 'pfmea', sources: [{ module: 'pfmea-cp', resource: 'documents', label: 'PFMEA' }] },
  { section: 'control-plans', sources: [{ module: 'pfmea-cp', resource: 'control-plans', label: '控制计划' }] },
  { section: 'issues', sources: [{ module: 'issues', resource: 'issues', label: '问题 / 8D' }] },
  { section: 'changes', sources: [{ module: 'changes', resource: 'changes', label: '工程变更' }] },
  { section: 'team', sources: [{ module: 'hr', resource: 'project-members', label: '团队成员' }] },
  { section: 'files', sources: [{ module: 'documents', resource: 'documents', label: '项目文件' }] },
];


/**
 * 交付物与团队成员这两个子页不是通用模块记录，走的是项目专属接口，
 * 所以字段单独定义在这里，让它们也能用同一个「详细录入」弹窗。
 *
 * 之前把这两页排除在弹窗之外是判断失误：
 * 团队成员恰恰是最需要逐条录入的地方，而「+新增」当时只清空侧边栏、
 * 画面毫无变化，用起来就是点了没反应。
 */
export const projectSectionFields: Record<string, ModuleField[]> = {
  /*
   * 控制计划有自己的一套表头（AIAG CP 封面），和 PFMEA 文档不是一回事。
   * 之前这里没定义，项目页的控制计划抽屉会退回去用 PFMEA 的字段——
   * 打开「控制计划」却在填「过程项失效描述」，填了也存不到该存的列。
   */
  'control-plans': [
    { key: 'code', label: '控制计划编号', required: true, group: '基本信息' },
    { key: 'title', label: '零件名称 / 描述', required: true, group: '基本信息' },
    { key: 'revision', label: '修订版', group: '基本信息' },
    { key: 'partNumber', label: '零件编号', group: '基本信息' },
    { key: 'phase', label: '涵盖阶段', type: 'select', options: ['Prototype', 'Pre-launch', 'Production'], group: '基本信息' },
    { key: 'customer', label: '顾客名称', group: '产品信息' },
    { key: 'modelYear', label: '车型 / 年款', group: '产品信息' },
    { key: 'engChangeLevel', label: '工程更改等级', group: '产品信息' },
    { key: 'parentId', label: '对应的 PFMEA', type: 'number', group: '关联与团队',
      help: '从本项目的 PFMEA 里选；控制计划的失效项与特殊特性由它带出，选错会导致特性对不上。' },
    { key: 'team', label: '核心团队', type: 'textarea', group: '关联与团队' },
    { key: 'issueDate', label: '发布日期', type: 'date', group: '关联与团队' },
    { key: 'revisionDate', label: '修订日期', type: 'date', group: '关联与团队' },
  ],
  deliverables: [
    { key: 'title', label: '交付物名称', required: true, group: '基本信息' },
    { key: 'code', label: '交付物编码', group: '基本信息' },
    /*
      0922：挂节点从选填改成必填。
      DH25017 有 4 条「X04-C出风口」，同一个人 09-10 / 09-12 / 09-15 / 09-21 各建了一次——
      没挂节点的交付物在阶段工作页上看不到，他每次都以为没建上。
      后端同一天也加了拦截（判据在那边），这里让人在点保存之前就看见。
    */
    { key: 'nodeId', label: '挂在哪个计划节点', type: 'number', required: true, group: '关联与责任',
      help: '必填：不挂节点的交付物在阶段工作页上看不到，也算不出该什么时候完成、该谁评审。'
        + '下拉没有可选项说明本项目还没排计划——先去「阶段工作」排。' },
    { key: 'ownerUserId', label: '责任人', type: 'number', group: '关联与责任',
      help: '从公司通讯录里选；选中后才会收到待办与审批通知。' },
    { key: 'ownerName', label: '责任人姓名', group: '关联与责任',
      help: '选人后自动带出，一般不用动。' },
    { key: 'dueDate', label: '要求完成日期', type: 'date', group: '关联与责任',
      help: '留空就跟着上面那个节点的计划完成日期走，节点改期会自动跟上；'
        + '自己填了就以你填的为准，之后节点改期也不会覆盖。' },
    { key: 'documentId', label: '交付物正文文件', type: 'number', group: '文件',
      help: '从项目已有文件里选；留空就先建记录，之后在右侧上传正文。' },
  ],
  team: [
    // parentId 会在 ProjectSectionView 里被替换成通讯录下拉，选中后自动带出姓名。
    // 原来是「姓名自由填 + 系统用户 ID 手填数字」——没人知道自己是几号，
    // 填错或不填，这个成员就收不到任何待办和审批通知。
    { key: 'parentId', label: '选择成员', type: 'number', required: true, group: '成员信息',
      help: '从公司通讯录里选人；选中后才能收到待办与审批通知' },
    { key: 'code', label: '项目角色', required: true, group: '成员信息',
      help: '如「PMC工程师（注塑）」；角色名要与审批流中的角色一致，否则审批派不到人' },
    { key: 'title', label: '成员姓名', group: '成员信息',
      help: '选人后自动带出；确有需要（如外部人员）可手工覆盖' },
    { key: 'ownerName', label: '邮箱', group: '成员信息' },
  ],
};

export function projectSectionByKey(section: string): ProjectSectionBinding | undefined {
  return projectSectionBindings.find((item) => item.section === section);
}

export function moduleByKey(key: string): ModuleDefinition | undefined {
  return modules.find((item) => item.key === key);
}

/*
  「谁看得到哪几个模块」只留这一把尺子。
  原来侧栏、模块中心各自 filter 一遍，指挥台的快速入口漏了第三遍——
  普通人在首页照样看到 ORG / CFG，点进去被路由踢回首页
  （Tony 2026-09-01：不是给大家用的，摆在那儿还容易引起误会）。
  收的是运维模块，业务模块一个不少。
*/
export function visibleModulesFor(canManageUsers: boolean): ModuleDefinition[] {
  return modules.filter((item) => !item.adminOnly || canManageUsers);
}

/*
  项目内常用页。图纸气泡、BOM、PPAP 这些没有跨项目的清单——
  接口全长在 /projects/:projectId/… 下面——所以它们进不了上面那张模块表，
  只能「先认一个项目，再进去」。摆在快速入口里，是为了省掉
  「项目组合 → 翻到那个项目 → 找 tab」这三步。
*/
export const projectShortcuts = [
  { suffix: 'drawings', code: 'DWG', label: '图纸气泡' },
  { suffix: 'bom', code: 'BOM', label: 'BOM' },
  { suffix: 'ppap', code: 'PPAP', label: 'PPAP' },
  { suffix: 'deliverables', code: 'DLV', label: '交付物' },
  { suffix: 'plan', code: 'PLAN', label: '计划甘特' },
  { suffix: 'files', code: 'FILE', label: '项目文件' },
] as const;

export function routeForApiModule(moduleKey: string): string {
  return modules.find((item) => item.module === moduleKey)?.route || '/my-work';
}

const projectSectionForModule: Record<string, string> = {
  'project-management': 'overview',
  dfmea: 'dfmea',
  'pfmea-cp': 'pfmea',
  documents: 'files',
  issues: 'issues',
  changes: 'changes',
  hr: 'team',
};

export function projectPathForModule(moduleKey: string, projectId: unknown): string | null {
  const normalizedId = String(projectId ?? '').trim();
  if (!/^[1-9]\d*$/.test(normalizedId)) return null;
  const section = projectSectionForModule[moduleKey];
  return section ? `/projects/${normalizedId}/${section}` : null;
}
